import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import Dropdown from "react-bootstrap/Dropdown";
import { RiMoneyRupeeCircleLine } from "react-icons/ri";
import { RiHandCoinLine } from "react-icons/ri";
import { FaCubes } from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IoEyeOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { LuReceiptIndianRupee } from "react-icons/lu";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { axiosInstance } from "../../../axiosInstance";
import TablePagination from "@mui/material/TablePagination";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

function createData1(date, products, total, payment) {
  return {
    date,
    products,
    total,
    payment,
  };
}

const rows1 = [
  createData1(
    "01-Sep-2025",
    "Premium Interior Emulsion 10L × 2; Enamel 1L × 1",
    "₹3,250",
    "UPI"
  ),
  createData1(
    "01-Sep-2025",
    "Premium Interior Emulsion 10L × 2; Enamel 1L × 1",
    "₹3,250",
    "UPI"
  ),
  createData1(
    "01-Sep-2025",
    "Premium Interior Emulsion 10L × 2; Enamel 1L × 1",
    "₹3,250",
    "UPI"
  ),
  createData1(
    "01-Sep-2025",
    "Premium Interior Emulsion 10L × 2; Enamel 1L × 1",
    "₹3,250",
    "UPI"
  ),
];

function createData2(productName, current, minimum, last) {
  return {
    productName,
    current,
    minimum,
    last,
  };
}

const rows2 = [
  createData2("Exterior Paint 20L", "5", "10", "01-Sep-2025"),
  createData2("Exterior Paint 20L", "5", "10", "01-Sep-2025"),
  createData2("Exterior Paint 20L", "5", "10", "01-Sep-2025"),
];

function createData3(orderid, date, items, total, status) {
  return {
    orderid,
    date,
    items,
    total,
    status,
  };
}

const rows3 = [
  createData3("ORD-1123", "06-Sep-2025", "6", "₹24,600", "Pending"),
  createData3("ORD-1123", "06-Sep-2025", "6", "₹24,600", "Approved"),
  createData3("ORD-1123", "06-Sep-2025", "6", "₹24,600", "Dispatched"),
  createData3("ORD-1123", "06-Sep-2025", "6", "₹24,600", "Delivered"),
];

export const SubDashboard = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [dashboardCards, setDashboardCards] = useState({});
  const [chartData, setChartData] = useState([]);

  async function FetchChartData() {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        "/dashboard/subdistributor/cards-summary-view/"
      );
      if (response.data.status === "Success" || response.status === 200) {
        setDashboardCards(response.data.data);
        setChartData(response.data.data.results?.[0] ?? []);
        console.log("Fetched chart data successfully!");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to fetch chart and card data"
      );
      console.log("Failed to fetch chart and card data");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchChartData();
  }, []);
  // recent sales
  const [recentPage, setRecentPage] = useState(0);
  const [recentRowsPerPage, setRecentRowsPerPage] = useState(5);
  const [recentTotalCount, setRecentTotalCount] = useState(0);

  const handleRecentRowsPerPage = (event) => {
    setRecentRowsPerPage(+event.target.value);
    setRecentPage(0);
  };

  const [recentSales, setRecentSales] = useState({});
  async function FetchRecentSales() {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        "/dashboard/subdistributor/recent-sales/"
      );
      if (response.data.status === "Success" || response.status === 200) {
        setRecentSales(response.data?.data);
        setRecentTotalCount(response.data?.data.count);
        console.log("Fetched recent sales successfully!");
      }
    } catch (error) {
      toast.error(error.response.data.status || "Failed to fetch recent sales");
      console.log("Failed to fetch recent sales");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchRecentSales();
  }, [recentPage, recentRowsPerPage]);

  // Low stock alerts
  const [lowPage, setLowPage] = useState(0);
  const [lowRowsPerPage, setLowRowsPerPage] = useState(5);
  const [lowTotalCount, setLowTotalCount] = useState(0);

  const handleLowRowsPerPage = (event) => {
    setLowRowsPerPage(+event.target.value);
    setLowPage(0);
  };
  const [lowStockDetails, setLowStockDetails] = useState({});

  async function FetchLowStockDetails() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: lowPage + 1,
          page_size: lowRowsPerPage,
        },
      };
      const response = await axiosInstance.get(
        "/inventory/subdistributor/low-stock/",
        config
      );
      if (response.data.status === "Success" || response.status === 200) {
        setLowStockDetails(response.data.data);
        setLowTotalCount(response.data?.data.count);
        console.log("Low stock details fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch low stock details"
      );
      console.log("Failed to fetch low stock details");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    FetchLowStockDetails();
  }, [lowPage, lowRowsPerPage]);

  // Recent Reorders to State Distributor
  const [reorderPage, setReorderPage] = useState(0);
  const [reorderRowsPerPage, setReorderRowsPerPage] = useState(5);
  const [reorderTotalCount, setReorderTotalCount] = useState(0);

  const handleReorderRowsPerPage = (event) => {
    setReorderRowsPerPage(+event.target.value);
    setReorderPage(0);
  };
  const [recentReorderData, setRecentReorderData] = useState({});
  async function FetchRecentReorderData() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: reorderPage + 1,
          page_size: reorderRowsPerPage,
        },
      };
      const response = await axiosInstance.get(
        "/dashboard/subdistributor/recent-order/",
        config
      );
      if (response.data.status === "success" || response.status === 200) {
        setRecentReorderData(response.data?.data);
        setReorderTotalCount(response.data?.data?.count);
        console.log("Recent reorders fetched successfully!");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch recent reorders data"
      );
      console.log("Failed to fetch recent reorders data");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchRecentReorderData();
  }, [reorderPage, reorderRowsPerPage]);

  const themeColor = getComputedStyle(document.documentElement)
    .getPropertyValue("--color-theme")
    .trim();
  const data = {
    labels: chartData?.map((item) => item.date),
    datasets: [
      {
        type: "bar",
        label: "Sales Value (₹)",
        data: chartData?.map((item) => item.total_amount),
        backgroundColor: themeColor,
        borderColor: themeColor,
        borderWidth: 1,
        yAxisID: "y", // left axis
        barPercentage: 0.4,
        categoryPercentage: 0.6,
      },
      {
        type: "line",
        label: "Orders Count",
        data: chartData?.map((item) => item.order_count),
        borderColor: "#10B981",
        backgroundColor: "#10B981",
        yAxisID: "y1", // right axis
        tension: 0.4,
        pointRadius: 4,
        pointBackgroundColor: "#10B981",
        pointBorderColor: "#fff",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          padding: 15,
        },
      },
      tooltip: {
        usePointStyle: true,
        callbacks: {
          label: (context) => {
            if (context.dataset.label === "Sales Value (₹)") {
              return `Sales: ₹${context.formattedValue}`;
            }
            return `Orders: ${context.formattedValue}`;
          },
        },
      },
    },
    scales: {
      y: {
        type: "linear",
        position: "left",
        ticks: {
          callback: (value) => new Intl.NumberFormat("en-IN").format(value),
        },
        grid: {
          drawOnChartArea: true,
        },
      },
      y1: {
        type: "linear",
        position: "right",
        grid: {
          drawOnChartArea: false, // no grid lines for right axis
        },
        ticks: {
          stepSize: 5,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="dashboardContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div className="dasboardTitle">
              <div>Dashboard</div>
              <div>Quick overview of your stock, orders, and sales.</div>
            </div>
            <div className="d-flex gap-2">
              <div>{""}</div>
              <div className="inventoryBtnReorder">
                <button onClick={() => navigate("/sub-sales")}>New Sale</button>
              </div>
            </div>
          </div>
          <div className="dashboardCardsPart">
            <div className="dashboardCard">
              <div className="dashboardCardIcon">
                <LuReceiptIndianRupee />
              </div>
              <div className="dashboardCardContent">
                <div>This Month Sales</div>
                <div>
                  {" "}
                  ₹ {dashboardCards?.dashboard_card?.this_month_sales ?? "---"}
                </div>
              </div>
            </div>
            <div className="dashboardCard">
              <div className="dashboardCardIcon">
                <RiMoneyRupeeCircleLine />
              </div>
              <div className="dashboardCardContent">
                <div>Today Sales</div>
                <div>
                  {" "}
                  ₹ {dashboardCards?.dashboard_card?.todys_sale ?? "---"}
                </div>
              </div>
            </div>
            <div className="dashboardCard">
              <div className="dashboardCardIcon">
                <FaCubes />
              </div>
              <div className="dashboardCardContent">
                <div>Current Stock Value</div>
                <div>
                  {" "}
                  ₹{" "}
                  {dashboardCards?.dashboard_card?.current_stock_value ?? "---"}
                </div>
              </div>
            </div>
            <div className="dashboardCard">
              <div className="dashboardCardIcon">
                <RiHandCoinLine />
              </div>
              <div className="dashboardCardContent">
                <div>Dues To Distributor</div>
                <div>
                  {" "}
                  ₹{" "}
                  {dashboardCards?.dashboard_card?.dues_to_distributor ?? "---"}
                </div>
              </div>
            </div>
          </div>

          {/* sales chart  */}
          <div className="titleOrderList">Sales Trend</div>
          <div className="salesChartContainer">
            <div
              className="chart-width"
              style={{ height: "300px", width: "100%" }}
            >
              <Bar data={data} options={options} />
            </div>
          </div>
          {/* order list  */}
          <div className="viewallContainer">
            <div className="titleOrderList">Recent Sales(POS)</div>
            <div className="viewallText">
              <Link to="/sub-dashboard-viewallsales">View All</Link>
            </div>
          </div>

          {/* table 1  */}
          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell align="left">Date</TableCell>
                    <TableCell align="left">
                      Products Sold (Name + UOM + Qty)
                      {/* Name */}
                    </TableCell>
                    {/* <TableCell align="left">UOM</TableCell>
                    <TableCell align="left">Qty</TableCell> */}
                    <TableCell align="left">Total Amount (₹)</TableCell>
                    <TableCell align="left">Payment Mode</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {recentSales?.results?.length > 0 ? (
                    recentSales?.results?.map((row) => (
                      <TableRow
                        key={row.product_name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell align="left">
                          {row.order_date ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.product && row.product.length > 0
                            ? row.product.map((item, index) => (
                                <div key={index}>
                                  {item.product_name}, ({item.uom}) × {item.qty}
                                </div>
                              ))
                            : "---"}
                        </TableCell>

                        <TableCell align="left">
                          {row.total_amount ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.payment_mode ?? "---"}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        align="center"
                        style={{ padding: "20px" }}
                      >
                        Data not available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={recentTotalCount}
              page={recentPage}
              onPageChange={(event, newPage) => setRecentPage(newPage)}
              rowsPerPage={recentRowsPerPage}
              onRowsPerPageChange={handleRecentRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]}
            />
          </div>
          {/* payment and dues table  */}
          <div className="titleOrderList">Low Stock Alerts</div>
          {/* table 2  */}

          <div className="dashboardTableContainer mt-4">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell align="left">Product Name</TableCell>
                    <TableCell align="left">Current Stock</TableCell>
                    <TableCell align="left">Minimum Level</TableCell>
                    <TableCell align="left">Last Received</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {lowStockDetails?.results?.length > 0 ? (
                    lowStockDetails.results.map((row) => (
                      <TableRow
                        key={row.name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell align="left">
                          {row.product ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.current_stock ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.min_stock_level ?? "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.last_import ?? "---"}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        align="center"
                        style={{ padding: "20px" }}
                      >
                        Data not available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={lowTotalCount}
              page={lowPage}
              onPageChange={(event, newPage) => setLowPage(newPage)}
              rowsPerPage={lowRowsPerPage}
              onRowsPerPageChange={handleLowRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]}
            />
          </div>
          {/* Recent Reorders to State Distributor */}
          <div className="titleOrderList">
            Recent Reorders to State Distributor
          </div>

          {/* table 3 */}
          <div className="dashboardTableContainer mt-4">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell align="left">Order ID</TableCell>
                    <TableCell align="left">Date</TableCell>
                    <TableCell align="left">Items Count</TableCell>
                    <TableCell align="left">Total Value (₹)</TableCell>
                    <TableCell align="left">Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {recentReorderData?.results?.length > 0 ? (
                    recentReorderData?.results?.map((row) => (
                      <TableRow
                        key={row.name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell align="left">{row.order_id}</TableCell>
                        <TableCell align="left">{row.order_date}</TableCell>
                        <TableCell align="left">{row.items}</TableCell>
                        <TableCell align="left">{row.total_amount}</TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: (() => {
                              switch (row.status) {
                                case "Pending":
                                  return "#EF4444";
                                case "Approved":
                                  return "#45614C";
                                case "Dispatched":
                                  return "#F59E0B";
                                case "Delivered":
                                  return "#10B981";
                                default:
                                  return "var(--color-font-secondary)";
                              }
                            })(),
                          }}
                        >
                          {row.status}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        align="center"
                        style={{ padding: "20px" }}
                      >
                        Data not available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={reorderTotalCount}
              page={reorderPage}
              onPageChange={(event, newPage) => setReorderPage(newPage)}
              rowsPerPage={reorderRowsPerPage}
              onRowsPerPageChange={handleReorderRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]}
            />
          </div>
        </div>
      </div>
    </>
  );
};
